<script setup>
import { useRoute } from '@js/utils/route';

const { tenant, aiProductImage, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    aiProductImage: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

function action() {
    axios
        .post(
            route(
                'front.projectManagement.ai.postToggleProductImageValidatedAt',
                {
                    tenant: tenant.id,
                    aiProductImage: aiProductImage.id,
                },
            ),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" />
</template>
